import React  , { useState  ,useContext  } from 'react'; 
import   'scss/components/page-components/Layout.scss';
import Navbar from 'js/components/page-components/Layout/Navbar.js';
import { produce } from 'immer';
import AppContext from  'js/Contexts/App.js'; 
import QuicknavSidebar from 'js/components/page-components/Layout/QuicknavSidebar.jsx';


const Layout = (props) => {
    const appContext = useContext(AppContext);

    const setShowSideBar = (open)=>{
        appContext.setMainLayoutState(produce( appContext.mainLayoutState , draft => {
            draft.foldOutOpen = open;
        }));
    }
    const currentAccount = appContext.appReducer.getCurrentAccountWithData();
    return  (
    <div className="L_AppMainLayout" key={'default-layout'} >
           <Navbar showSideBar={appContext.mainLayoutState.foldOutOpen} setShowSideBar={setShowSideBar} /> 
           <div className="layoutMainContentHolder"  >
                 { appContext.mainLayoutState.foldOutOpen && <div className="sidebarOverlay" onClick={() => setShowSideBar(false)}></div> }
                 { appContext.mainLayoutState.foldOutOpen && <QuicknavSidebar currentAccount={currentAccount} /> }
            { props.children }
           </div> 
    </div> );
}

export default Layout ;
   